import React, { useState, useEffect, useRef } from "react";

import {

    faCircleInfo,

    faCrosshairs

}

from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon }

from "@fortawesome/react-fontawesome";

import AiInsightCard from './AiInsightCard';

import AiAssetCard from './AiAssetCard';

import AssetDetails from './AssetDetails';

import AssetAiDrawer from "./AssetAiDrawer";

import SlidingDrawer from './SlidingDrawer';

import useAiInsights from '../hooks/useAiInsights';

import SearchHeader from '../../../components/SearchHeader';

import ScrollableList from '../../../components/ScrollableList';

import KpiCounter from './KpiCounter';

import AssetMaintenanceDrawer from "./AssetMaintenanceDrawer";

import AssetDocumentsDrawer from "./AssetDocumentsDrawer";

import AssetInspectionDrawer from "./AssetInspectionDrawer";

import AssetInsightsDrawer from "./AssetInsightsDrawer";


export default function GiraffeViewer({

    url,

    onHotspotClick,

    aiDrawerVisible,

    setAiDrawerVisible

})

{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [selectedSeverity, setSelectedSeverity] =
        useState("CRITICAL");

    const [expandedInsight, setExpandedInsight] =
        useState(0);

    const [expandedAsset, setExpandedAsset] =
        useState(0);

    const [view, setView] =
        useState("insights");

    const [search, setSearch] =
        useState("");

    const [assetDetailsDrawerVisible, setAssetDetailsDrawerVisible] =
        useState(false);

    const [documentsOpen, setDocumentsOpen] =
        useState(false);

    const [maintenanceOpen, setMaintenanceOpen] =
        useState(false);

    const [inspectionOpen, setInspectionOpen] =
        useState(false);

    const [insightsOpen, setInsightsOpen] =
        useState(false);

    const [assetAiOpen, setAssetAiOpen] =
        useState(false);


    //--------------------------------------------------------
    // Viewer Reference
    //--------------------------------------------------------

    const viewerRef =
        useRef();


    //--------------------------------------------------------
    // List Heights
    //--------------------------------------------------------

    const listHeightInsights =
        window.innerHeight - 180;

    const listHeightAssets =
        window.innerHeight - 200;


    //--------------------------------------------------------
    // AI Insights
    //--------------------------------------------------------

    const
    {

        loading,

        insights,

        insightSummary,

        assets,

        reload

    }

    =

    useAiInsights(
        '',
        assetDetailsDrawerVisible
    );


    //--------------------------------------------------------
    // Filter Assets
    //--------------------------------------------------------

    const filteredAssets =

        assets.filter(asset =>
        {

            const text =

            (

                asset.name +

                " " +

                asset.assetType +

                " " +

                asset.location +

                " " +

                asset.description

            ).toLowerCase();


            return text.includes(
                search.toLowerCase()
            );

        });


    //--------------------------------------------------------
    // Frame Style
    //--------------------------------------------------------

    const frameStyle =
    {

        display:
            "flex",

        marginTop:
            "0px",

        marginLeft:
            "60px",

        width:
            "calc(100% - 60px)",

        height:
            "calc(100vh - 0px)"

    };


    //--------------------------------------------------------
    // Giraffe Hotspot Listener
    //--------------------------------------------------------

    useEffect(function ()
    {

        const handleMessage =
            (event) =>
            {

                console.log(
                    "MESSAGE RECEIVED",
                    event
                );


                const tourFrame =
                    viewerRef.current;


                if (!tourFrame)
                {
                    return;
                }


                if (event.source !== tourFrame.contentWindow)
                {
                    return;
                }


                if (event.data?.type !== 'g360:info-hotspot-click')
                {
                    return;
                }


                const
                {

                    hotspotId,

                    sceneKey,

                    content

                } = event.data;


                if (onHotspotClick)
                {

                    onHotspotClick(
                        hotspotId
                    );

                }

            };


        window.addEventListener(
            'message',
            handleMessage
        );


        return () =>
        {

            window.removeEventListener(
                'message',
                handleMessage
            );

        };

    }, [onHotspotClick]);


    //--------------------------------------------------------
    // Show Asset Details
    //--------------------------------------------------------

    const showAssetDetails = () =>
    {

        setDocumentsOpen(false);

        setMaintenanceOpen(false);

        setInspectionOpen(false);

        setInsightsOpen(false);

        setAssetAiOpen(false);


        let timer =
            setTimeout(() =>
            {

                setAssetDetailsDrawerVisible(
                    true
                );

            }, 50);

    };


    //--------------------------------------------------------
    // Hide Asset Details
    //--------------------------------------------------------

    const hideAssetDetails = () =>
    {

        setAssetAiOpen(false);

        setDocumentsOpen(false);

        setMaintenanceOpen(false);

        setInspectionOpen(false);

        setInsightsOpen(false);

        setAssetDetailsDrawerVisible(false);

    };


    //--------------------------------------------------------
    // Open Documents
    //--------------------------------------------------------

    const openDocuments = () =>
    {

        setMaintenanceOpen(false);

        setInspectionOpen(false);

        setInsightsOpen(false);

        setAssetAiOpen(false);

        setDocumentsOpen(true);

    };


    //--------------------------------------------------------
    // Open Maintenance
    //--------------------------------------------------------

    const openMaintenance = () =>
    {

        setDocumentsOpen(false);

        setInspectionOpen(false);

        setInsightsOpen(false);

        setAssetAiOpen(false);

        setMaintenanceOpen(true);

    };


    //--------------------------------------------------------
    // Open AI Insights
    //--------------------------------------------------------

    const openInsights = () =>
    {

        setDocumentsOpen(false);

        setMaintenanceOpen(false);

        setInspectionOpen(false);

        setAssetAiOpen(false);

        setInsightsOpen(true);

    };


    //--------------------------------------------------------
    // Open AI Asset Intelligence
    //--------------------------------------------------------

    const openAssetAi = () =>
    {

        setDocumentsOpen(false);

        setMaintenanceOpen(false);

        setInspectionOpen(false);

        setInsightsOpen(false);

        setAssetAiOpen(true);

    };


    //--------------------------------------------------------
    // AI Survey Drawer Style
    //--------------------------------------------------------

    const drawer =
    {

        position:
            "absolute",

        top:
            "0px",

        right:
            aiDrawerVisible
                ? "0px"
                : "-470px",

        width:
            "480px",

        height:
            "100%",

        background:
            "linear-gradient(180deg, rgba(32,36,44,.98) 0%, rgba(14,16,22,.99) 100%)",

        borderLeft:
            "1px solid rgba(255,255,255,.08)",

        boxShadow:
            "-20px 0 60px rgba(0,0,0,.55)",

        transition:
            "right .95s cubic-bezier(.22,1,.36,1)",

        overflow:
            "hidden",

        display:
            "flex",

        flexDirection:
            "column",

        zIndex:
            99999

    };


    //--------------------------------------------------------
    // RAG Counter
    //--------------------------------------------------------

    const buildRag =
        (
            title,
            value,
            colour,
            severity
        ) =>
        (

            <div

                onClick={() =>
                    setSelectedSeverity(
                        severity
                    )
                }

                style={{

                    display:
                        "flex",

                    flexDirection:
                        "column",

                    alignItems:
                        "center",

                    width:
                        "110px",

                    cursor:
                        "pointer",

                    transform:
                        selectedSeverity === severity
                            ? "scale(1.08)"
                            : "scale(1)",

                    transition:
                        ".25s"

                }}

            >

                <div

                    style={{

                        width:
                            "54px",

                        height:
                            "54px",

                        borderRadius:
                            "50%",

                        background:
                            `linear-gradient(
                                180deg,
                                ${colour} 0%,
                                ${colour}DD 55%,
                                ${colour}AA 100%
                            )`,

                        display:
                            "flex",

                        justifyContent:
                            "center",

                        alignItems:
                            "center",

                        color:
                            "white",

                        fontSize:
                            "21px",

                        fontWeight:
                            500,

                        boxShadow:
                            `0 0 18px ${colour}99,
                             0 0 40px ${colour}33`

                    }}

                >

                    <KpiCounter

                        value={value}

                        colour="#d62828"

                    />

                </div>


                <div

                    style={{

                        marginTop:
                            "12px",

                        color:
                            selectedSeverity === severity
                                ? "#fff"
                                : "rgba(255,255,255,.65)",

                        fontWeight:
                            700,

                        fontSize:
                            "13px"

                    }}

                >

                    {title}

                </div>

            </div>

        );


    //--------------------------------------------------------
    // AI Survey Display Panel
    //--------------------------------------------------------

    const displayPanel =

        view === "insights"

            ?

            <>

                <div

                    style={{

                        display:
                            "flex",

                        justifyContent:
                            "space-around",

                        padding:
                            "22px",

                        borderBottom:
                            "1px solid rgba(255,255,255,.08)"

                    }}

                >

                    {
                        buildRag(
                            "Critical",
                            insightSummary.critical,
                            "#d62828",
                            "CRITICAL"
                        )
                    }

                    {
                        buildRag(
                            "Medium",
                            insightSummary.medium,
                            "#f39c12",
                            "MEDIUM"
                        )
                    }

                    {
                        buildRag(
                            "Low",
                            insightSummary.low,
                            "#2ecc71",
                            "LOW"
                        )
                    }

                    {
                        buildRag(
                            "N/A",
                            insightSummary.na,
                            "#666666",
                            "NA"
                        )
                    }

                </div>


                <div

                    style={{

                        flex:
                            1,

                        minHeight:
                            0,

                        paddingTop:
                            '10px',

                        paddingLeft:
                            '20px',

                        paddingRight:
                            '20px'

                    }}

                >

                    <ScrollableList
                        height={listHeightInsights}
                    >

                        {

                            insights

                                .filter(i =>
                                    i.severity ===
                                    selectedSeverity
                                )

                                .map(
                                    (
                                        insight,
                                        index
                                    ) =>

                                    <AiInsightCard

                                        key={index}

                                        insight={insight}

                                        expanded={
                                            expandedInsight ===
                                            index
                                        }

                                        onToggle={() =>
                                            setExpandedInsight(

                                                expandedInsight ===
                                                index

                                                    ? -1

                                                    : index

                                            )
                                        }

                                        onLocate={() =>
                                        {

                                            alert(
                                                "Locate in Scan"
                                            );

                                        }}

                                    />

                                )

                        }

                    </ScrollableList>

                </div>

            </>

            :

            <div

                style={{

                    display:
                        "flex",

                    flexDirection:
                        "column",

                    height:
                        "100%",

                    paddingLeft:
                        "20px",

                    paddingRight:
                        "20px"

                }}

            >

                <SearchHeader

                    placeholder="Search assets..."

                    value={search}

                    onChange={setSearch}

                    count={filteredAssets.length}

                    label="Assets"

                />


                <div

                    style={{

                        flex:
                            1,

                        minHeight:
                            0,

                        paddingTop:
                            '10px'

                    }}

                >

                    <ScrollableList
                        height={listHeightAssets}
                    >

                        {

                            filteredAssets.map(
                                (
                                    asset,
                                    index
                                ) =>

                                <AiAssetCard

                                    key={asset.id}

                                    asset={asset}

                                    expanded={
                                        expandedAsset ===
                                        index
                                    }

                                    onToggle={() =>
                                        setExpandedAsset(

                                            expandedAsset ===
                                            index

                                                ? -1

                                                : index

                                        )
                                    }

                                    onLocate={() =>
                                    {

                                        alert(
                                            "Locate in Scan"
                                        );

                                    }}

                                    onDetail={
                                        showAssetDetails
                                    }

                                />

                            )

                        }

                    </ScrollableList>

                </div>

            </div>;


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div

            style={{

                position:
                    "relative",

                width:
                    "100%",

                height:
                    "100%"

            }}

        >

            {/*========================================================
              Giraffe Viewer
            ========================================================*/}

            <iframe

                ref={viewerRef}

                src={url}

                style={frameStyle}

                frameBorder="0"

                title="Giraffe 360 Viewer"

            />


            {/*========================================================
              AI Survey Drawer
            ========================================================*/}

            <div style={drawer}>

                <div

                    style={{

                        display:
                            "flex",

                        justifyContent:
                            "space-between",

                        alignItems:
                            "center",

                        padding:
                            "16px 22px",

                        borderBottom:
                            "1px solid rgba(255,255,255,.08)"

                    }}

                >

                    <div

                        style={{

                            display:
                                "flex",

                            alignItems:
                                "center",

                            gap:
                                "18px"

                        }}

                    >

                        <div

                            style={{

                                display:
                                    "flex",

                                background:
                                    "rgba(255,255,255,.08)",

                                border:
                                    "1px solid rgba(255,255,255,.12)",

                                borderRadius:
                                    "0px",

                                overflow:
                                    "hidden"

                            }}

                        >

                            <div

                                onClick={() =>
                                    setView(
                                        "insights"
                                    )
                                }

                                style={{

                                    height:
                                        "42px",

                                    display:
                                        "flex",

                                    alignItems:
                                        "center",

                                    justifyContent:
                                        "center",

                                    background:
                                        view === "insights"
                                            ? "linear-gradient(180deg, #42bff5 0%, #159bd7 100%)"
                                            : "transparent",

                                    color:
                                        "#fff",

                                    fontSize:
                                        "14px",

                                    fontWeight:
                                        500,

                                    width:
                                        '120px',

                                    cursor:
                                        "pointer",

                                    transition:
                                        ".2s",

                                    userSelect:
                                        "none"

                                }}

                            >

                                Insights

                            </div>


                            <div

                                onClick={() =>
                                    setView(
                                        "assets"
                                    )
                                }

                                style={{

                                    height:
                                        "42px",

                                    display:
                                        "flex",

                                    alignItems:
                                        "center",

                                    justifyContent:
                                        "center",

                                    background:
                                        view === "assets"
                                            ? "linear-gradient(180deg, #42bff5 0%, #159bd7 100%)"
                                            : "transparent",

                                    color:
                                        "#fff",

                                    fontSize:
                                        "14px",

                                    fontWeight:
                                        500,

                                    width:
                                        '120px',

                                    cursor:
                                        "pointer",

                                    transition:
                                        ".2s",

                                    userSelect:
                                        "none"

                                }}

                            >

                                Assets

                            </div>

                        </div>

                    </div>


                    <div

                        onClick={() =>
                            setAiDrawerVisible(
                                false
                            )
                        }

                        style={{

                            width:
                                "34px",

                            height:
                                "34px",

                            borderRadius:
                                "50%",

                            background:
                                "rgba(255,255,255,.08)",

                            display:
                                "flex",

                            alignItems:
                                "center",

                            justifyContent:
                                "center",

                            cursor:
                                "pointer",

                            color:
                                "#fff",

                            fontSize:
                                "17px",

                            transition:
                                "1.6s"

                        }}

                    >

                        ✕

                    </div>

                </div>


                {displayPanel}

            </div>


            {/*========================================================
              Asset Details Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={
                    assetDetailsDrawerVisible
                }

                width={500}

                offset={0}

                zIndex={9999999}

                title="Asset Details"

                onClose={
                    hideAssetDetails
                }

            >

                <AssetDetails

                    demoScenario="FCU"

                    onDocuments={
                        openDocuments
                    }

                    onMaintenance={
                        openMaintenance
                    }

                    onInsights={
                        openInsights
                    }

                    onAi={
                        openAssetAi
                    }

                />

            </SlidingDrawer>


            {/*========================================================
              AI Asset Intelligence Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={
                    assetAiOpen
                }

                width={650}

                offset={500}

                zIndex={9999998}

                title="AI Asset Intelligence"

                onClose={() =>
                    setAssetAiOpen(
                        false
                    )
                }

            >

                <AssetAiDrawer

                    assetType="Fan Coil Unit"

                    manufacturer="Daikin"

                    model="FWE06CT"

                />

            </SlidingDrawer>


            {/*========================================================
              Documents Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={
                    documentsOpen
                }

                width={900}

                offset={500}

                zIndex={9999998}

                title="Documents"

                onClose={() =>
                    setDocumentsOpen(
                        false
                    )
                }

            >

                <AssetDocumentsDrawer />

            </SlidingDrawer>


            {/*========================================================
              Maintenance Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={
                    maintenanceOpen
                }

                width={380}

                offset={500}

                zIndex={9999998}

                title="Maintenance"

                onClose={() =>
                    setMaintenanceOpen(
                        false
                    )
                }

            >

                <AssetMaintenanceDrawer

                    onSelectInspection={() =>
                        setInspectionOpen(
                            true
                        )
                    }

                />

            </SlidingDrawer>


            {/*========================================================
              Inspection Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={
                    inspectionOpen
                }

                width={420}

                offset={880}

                zIndex={9999997}

                title="Inspection"

                onClose={() =>
                    setInspectionOpen(
                        false
                    )
                }

            >

                <AssetInspectionDrawer />

            </SlidingDrawer>


            {/*========================================================
              AI Insights Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={
                    insightsOpen
                }

                width={380}

                offset={500}

                zIndex={9999998}

                title="AI Insights"

                onClose={() =>
                    setInsightsOpen(
                        false
                    )
                }

            >

                <AssetInsightsDrawer />

            </SlidingDrawer>

        </div>

    );

}